
export const createSettingsJsonData = (usersFilter, sorting, workAssignmentsFilter, nUsersPerPage) => {
    return {
        usersFilter: usersFilter,
        sorting: sorting,
        workAssignmentsFilter: workAssignmentsFilter,
        nUsersPerPage: nUsersPerPage,
    }
}

export const convertSettingsJsonData = (jsonData) => {
    let settings = {}
    if (jsonData) {
        if (jsonData.usersFilter !== undefined)
            settings.usersFilter = jsonData.usersFilter
        if (jsonData.workAssignmentsFilter !== undefined)
            settings.workAssignmentsFilter = jsonData.workAssignmentsFilter
        if (jsonData.sorting !== undefined)
            settings.sorting = jsonData.sorting
        if (jsonData.nUsersPerPage !== undefined)
            settings.nUsersPerPage = jsonData.nUsersPerPage
    }
    return settings
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/utils.js